const en_goods = {
    add: "add goods",
    barcode: "barcode",
    edit: "edit goods",
    name: 'goods name',
    order_min: "minimum order",
    price: "price goods",
    stock_min: 'minimum stock warning',
    upload: "upload goods",
    // barcode: "print barcode",
    view: "goods detail",
    error: {
        brand: 'pricipal cannot be empty',
        category: 'goods category cannot be empty',
        name: 'goods name cannot be empty',
        unit: 'goods unit cannot be empty',
    }
}

const id_goods = {
    add: "tambah barang",
    barcode: "barcode",
    edit: "ubah barang",
    name: 'nama barang',
    order_min: "minimum pesanan",
    price: "harga barang",
    stock_min: 'peringatan minimum stok',
    upload: "unggah barang",
    // barcode: "cetak barcode",
    view: "detail barang",
    error: {
        barcode: 'barcode tidak boleh kosong',
        brand: 'pricipal tidak boleh kosong',
        category: 'kategori barang tidak boleh kosong',
        name: 'nama barang tidak boleh kosong',
        sku: 'SKU tidak boleh kosong',
        unit: 'unit barang tidak boleh kosong',
    }
}

export { en_goods, id_goods };